import React from 'react';

interface PodStatusProps {
  pod: any;
}

export const PodStatus: React.FC<PodStatusProps> = ({ pod }) => {
  // Check for deletion timestamp first - this indicates a pod is terminating
  // even if the phase still shows as Running
  const isTerminating = !!pod.metadata?.deletionTimestamp;
  
  // If terminating, show that status regardless of phase
  if (isTerminating) {
    return (
      <div className="flex items-center">
        <span className="w-2 h-2 rounded-full mr-2 bg-orange-500"></span>
        <span>Terminating</span>
        <span className="ml-2 text-xs font-medium text-slate-500">
          ({pod.status?.containerStatuses?.filter((c: any) => c.ready)?.length || 0}/
          {pod.status?.containerStatuses?.length || 0})
        </span>
      </div>
    );
  }

  // Otherwise, proceed with normal phase detection
  const phase = pod.status?.phase || 'Unknown';
  let color = 'bg-gray-500';
  
  if (phase === 'Running') color = 'bg-green-500';
  else if (phase === 'Pending') color = 'bg-yellow-500';
  else if (phase === 'Failed' || phase === 'Error') color = 'bg-red-500';
  
  // Calculate ready status based on ready conditions
  const readyContainers = pod.status?.containerStatuses?.filter((container: any) => container.ready)?.length || 0;
  const totalContainers = pod.status?.containerStatuses?.length || 0;
  const readyStatus = `${readyContainers}/${totalContainers}`;
  
  return (
    <div className="flex items-center">
      <span className={`w-2 h-2 rounded-full mr-2 ${color}`}></span>
      <span>{phase}</span>
      <span className="ml-2 text-xs font-medium text-slate-500">({readyStatus})</span>
    </div>
  );
};

export default PodStatus; 